/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==============================================================================
 * VAULTSURPLUS — Maillage Interne 2.0 : injection du bloc dans la description
 * ==============================================================================
 * Le bloc <p id="maillage_interne_2_0"> est rendu par la section
 * maillage-interne-2-0.liquid en bas de page. On le déplace dans la description
 * produit (.product-block-list__item--description .rte) pour un vrai SEO/UX.
 * ============================================================================ */
(function() {
  function insertMaillageInterne() {
    var mi2 = document.getElementById('maillage_interne_2_0');
    if (!mi2 || !mi2.textContent.trim()) return;

    // Try several selectors in order of preference
    var target =
      document.querySelector('.product-block-list__item--description .rte') ||
      document.querySelector('.product-block-list__item--description .card__collapsible-content .rte') ||
      document.querySelector('.product-block-list__item--description');

    if (target && !target.contains(mi2)) {
      target.appendChild(mi2);
      var wrapper = document.querySelector('.vs-internal-linking');
      if (wrapper) wrapper.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertMaillageInterne);
  } else {
    insertMaillageInterne();
  }
  // Also run after full load in case theme JS rebuilt DOM
  window.addEventListener('load', insertMaillageInterne);
})();
